import { apiMipe, api } from '@/core/api/';
import DocumentsService from '@/modules/shared/documents.api.js';

const apiUrl = 'api/dashboardpost';

export const getTypes = (payload) => {
  return apiMipe.get(`api/code/scheduleitemtypes`, {
    params: { ...payload },
  });
};

export const getApplications = (payload) => {
  return apiMipe.get(`api/code/application`, {
    params: { ...payload },
  });
};

export const getAllPosts = (payload) => {
  return apiMipe.get(`${apiUrl}`, {
    params: { ...payload },
  });
};

export const save = (payload) => {
  return apiMipe.post(`${apiUrl}`, payload);
};

export const get = (id) => {
  return apiMipe.get(`${apiUrl}/${id}`);
};

export const getAuthenticationMechanismTypes = () => {
  return apiMipe.get(`${apiUrl}/workshop/authtypes`);
};

export const changePostStatus = (postId, newStatus) => {
  return apiMipe.patch(`${apiUrl}/changestatus/${postId}`, newStatus);
};

export const getItemAreaTypes = () => {
  return apiMipe.get(`${apiUrl}/areatypes`);
};

export const getItemCategoryTypes = () => {
  return apiMipe.get(`${apiUrl}/categorytypes`);
};

export const getItemTagTypes = () => {
  return apiMipe.get(`${apiUrl}/tagtypes`);
};

export const getEducationalMaterialCategories = () => {
  return apiMipe.get(`${apiUrl}/educationalmaterial/categories`);
};

export const getWorkshopStatuses = () => {
  return apiMipe.get(`${apiUrl}/workshop/statuses`);
};

export const getAllWorkshop = (params) => {
  return apiMipe.get(`${apiUrl}/workshop/search`, { params });
};

export const getWorkshopDetail = (workshopId) => {
  return apiMipe.get(`${apiUrl}/workshop/${workshopId}`);
};

export const addWorkshopParticipant = (payload) => {
  return apiMipe.post(`${apiUrl}/addparticipant`, payload);
};

export const getLatestParticipant = () => {
  return apiMipe.get(`${apiUrl}/workshop/participant/lastRegistered`);
};

export const updateParticipantWorkshopStatus = (payload) => {
  return apiMipe.patch(`${apiUrl}/update/participant`, payload);
};

export const getEvents = (params) => {
  return apiMipe.get(`${apiUrl}/events/search`, { params });
};

export const redeemWorkshop = (payload) => {
  return apiMipe.post(`${apiUrl}/workshop/redeem`, payload);
};

export const getNews = () => {
  return apiMipe.get(`${apiUrl}/news`);
};

export const cardsbymodule = (moduleid) => {
  return apiMipe.get(`${apiUrl}/cardsbymodule?moduleid=${moduleid}`);
};

export const getCalendarCategories = () => {
  return apiMipe.get(`${apiUrl}/calendarcategories`);
};

export const getWorkshopMethodologyTypes = () => {
  return apiMipe.get(`${apiUrl}/methodology/types`);
};

export const getAllWorkshopParticipants = (params) => {
  return apiMipe.get(`${apiUrl}/workshop/participants/search`, { params });
};
export const getVideos = (payload) => {
  return apiMipe.get(`${apiUrl}/videos`, {
    params: { ...payload },
  });
};

export const getGuides = (payload) => {
  return apiMipe.get(`${apiUrl}/userguides`, {
    params: { ...payload },
  });
};

export const notifyWorkshopParticipantAbsence = (payload) =>
  apiMipe.post(`${apiUrl}/workshop/participants/notifyabsence`, payload);

export const getWorkshopParticipantLogs = (params) => {
  return apiMipe.get(`${apiUrl}/participantlog`, { params });
};

export const validateWorkshopTests = (id) => {
  return apiMipe.get(`${apiUrl}/workshop/validatetests?dashboardpostid=${id}`);
};

export const saveQuestionnaireConfig = (payload) => {
  return apiMipe.post(`${apiUrl}/save/questionnaire`, payload);
};

export const getWorkshopTests = (payload) => {
  return apiMipe.get(`${apiUrl}/tests`, {
    params: { ...payload },
  });
};

export const removeQuestionnaire = (payload) => {
  return apiMipe.put(`${apiUrl}/remove/questionnaire`, payload);
};

export const getQuestionnaire = (id) => {
  return apiMipe.get(`${apiUrl}/questionnaireType/${id}`);
};

export const getQuestionnaireQuestionTypes = () =>
  apiMipe.get(`${apiUrl}/questionnaire/questions/types`);

export const getReportTypes = () => {
  return apiMipe.get(`${apiUrl}/graphic/reportTypes`);
};

export const getGraphicTypes = () => {
  return apiMipe.get(`${apiUrl}/graphicTypes`);
};

export const getModules = (applicationId) =>
  apiMipe.get(`api/code/modules/${applicationId}`);

export const downloadWorkshopCertificate = async (id) => {
  const { data } = await apiMipe.get(`api/report/workshopcertificate/${id}`);
  DocumentsService.Download(data);
};

export const getDocument = (id) => {
  return api.get(`api/documents/${id}`);
};
